/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { IInfoCardProperty } from './IInfoCardProperty';
import { IInfoCardUserInputEvent } from './IInfoCardUserInputEvent';

/* eslint-disable no-unused-vars */
/**
 * InfoCardUserInputHandler provides base implementations for handling user input events
 * (such as left, right, and back key navigation) on an InfoCard.
 * Derived classes should override these methods to implement custom navigation logic.
 */
export abstract class InfoCardUserInputHandler implements IInfoCardUserInputEvent {
    private readonly TAG: string = 'InfoCardUserInputHandler';

    private log(message: string): void {
        Diagnostics.info(this.TAG, message);
    }

    /**
     * @inheritdoc
     */
    public onKeyLeft(properties: IInfoCardProperty): void {
        // The derived class needs to override this method to handle left key navigation
        this.log('onKeyLeft called');
    }

    /**
     * @inheritdoc
     */
    public onKeyRight(properties: IInfoCardProperty): void {
        // The derived class needs to override this method to handle left key navigation
        this.log('onKeyRight called');
    }

    /**
     * @inheritdoc
     */
    public onKeyBack(properties: IInfoCardProperty): void {
        // The derived class needs to override this method to handle back key navigation
        this.log('onKeyBack called');
    }
}
